import {
  SVG,
} from 'web-styled';

import * as S from '../styled';

const sidebarIcons = {
  dashboard: SVG.Home,
  billing: SVG.Billing,
  clients: SVG.Clients,
  individuals: SVG.Client,
  groups: SVG.Group,
  calendar: SVG.Calendar,
  exercises: SVG.Exercise,
  workout2: SVG.KettleBell,
  programs: SVG.Program,
  warmups: SVG.Warmup,
  cooldowns: SVG.Cooldown,
  videogallery: SVG.VideoLibrary,
  trainings: SVG.Trainings,
  properties: SVG.Metrics,
  marketplace: SVG.Transaction,
  documents: SVG.Document,
  messages: SVG.Messages,
};

type IconType = 'dashboard'
  | 'billing'
  | 'clients'
  | 'individuals'
  | 'groups'
  | 'calendar'
  | 'exercises'
  | 'workout2'
  | 'programs'
  | 'warmups'
  | 'cooldowns'
  | 'videogallery'
  | 'trainings'
  | 'properties'
  | 'marketplace'
  | 'documents'
  | 'messages';

interface Props {
  icon?: IconType
  level: number,
  isFolder?: boolean,
}

const ItemIcon = ({
  icon,
  level,
  isFolder,
}: Props) => {
  if (!icon) return null

  const Component = sidebarIcons[icon];
  return (level === 0 || !isFolder) ? (
    <S.SVGIcon>
      <Component className="sidebarIcons" />
    </S.SVGIcon>
  ) : (
    <SVG.Folder size={13} />
  );
};

export default ItemIcon;
